import React, { useState } from 'react';
import { instanceOf, func } from 'prop-types';
import LinesEllipsis from 'react-lines-ellipsis';
import DELabelEditableField from './DELabelEditableField';

const TargetLabelBodyRow = ({ row, saveLabel }) => {
  const paddingLeft = row.le * 12;
  const [hoverClass, setHoverClass] = useState('');
  const [isEditable, setIsEditable] = useState(false)
  const [selectedClass, setSelectedClass] = useState('')
  const getRowClass = () => {
    let rowClass = 'de--label--row__keyword';
    switch (row.ty) {
      case 'bracket':
        rowClass = 'de--label--row__parantheses';
        break;
      case 'misc':
        rowClass = 'de--label--row__misc';
        break;
      case 'operator':
        rowClass = 'de--label--row__operator';
        break;
      case 'function':
        rowClass = 'de--label--row__function';
        break;
      case 'delimiter':
        rowClass = 'de--label--row__delimiter';
        break;
      default:
        rowClass = 'de--label--row__keyword';
    }
    return rowClass;
  };

  const setHoverState = classname => {
    setHoverClass(classname);
  }

  const setEditable = isEdit => {
    setIsEditable(isEdit);
    setSelectedClass(isEdit ? 'de--label--row__selected' : '');
  }

  return (
    <div
      className={`de--label--row ${getRowClass()} ${hoverClass} ${selectedClass}`}
      onMouseEnter={() => setHoverState('de--label--row__hover')}
      onMouseLeave={() => setHoverState('')}
    >
      <div title={row.sl} className="de--label--row__leftCol" style={{ paddingLeft }}>
        <div className="de--label--element">
          <div className="de--label--element--label">
            <div className="de--label--element--label--text">
              <LinesEllipsis
                text={row.sl}
                maxLine='2'
                ellipsis='...'
                trimRight
                basedOn='letters'
              />
            </div>
          </div>
        </div>
        <div className="de--label--row__lefthover-overlay" />
      </div>
      <div
        className="de--label--row__rightCol"
        title={row.tl}
      >
        <DELabelEditableField
          row={row}
          saveLabel={saveLabel}
          isEditable={isEditable}
          setEditable={setEditable}
          removeHover={() => setHoverState('')}
          setHover={() => setHoverState('de--label--row__hover')}
        />
      </div>
    </div>
  );
};

TargetLabelBodyRow.propTypes = {
  row: instanceOf(Object),
  saveLabel: func,
};

export default TargetLabelBodyRow;
